import React from 'react'
import { Create } from 'react-admin'
import SponsorsForm from './form'

export const SponsorsCreate = (props) => (
  <Create {...props}>
    <SponsorsForm isEdit={false} {...props} />
  </Create>
)

export default SponsorsCreate
